module.exports = __webpack_public_path__ + "static/media/hero-video-poster-small.0c3c010c.webp";